import { render, staticRenderFns } from "./AdminItem.vue?vue&type=template&id=7194ca8b&scoped=true&"
import script from "./AdminItem.vue?vue&type=script&lang=js&"
export * from "./AdminItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7194ca8b",
  null
  
)

export default component.exports